import React from 'react';
import {Grid, IconButton, Typography} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {GetState} from "../../../redux/reduxhelper";
import {IS_AUTH} from "../../../redux/action/type.action";
import {useNavigate} from "react-router";
import {fixStringToHtml} from "../../../tools/helper";

const EventsCard = ({item}) => {

    const isAuth = GetState(IS_AUTH, false)
    const navigate = useNavigate();

    return (
        <Grid sx={{display: "flex", flexDirection: 'column ', gap: 2}}>
            {isAuth && <Grid sx={{textAlign: "right"}}>
                <IconButton onClick={() => navigate(`/admin/dashboard/event/${item?.id}`)}
                            sx={{color: "#592EA9", cursor: "pointer"}}
                >
                    <EditOutlinedIcon/>
                </IconButton></Grid>}
            <Grid key={item?.id} container sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '40px 10%',
                overflowX: 'hidden'
            }}>
                <Grid data-aos="fade-left"
                      data-aos-duration="2000"
                      data-aos-once="true"
                      data-aos-delay="000" item xs={12} md={4}
                      sx={{'& .img': {width: {xs: '100%', md: '95%'}}}}>
                    <img className={'img'} src={item?.image_url} alt="My Team"/>
                </Grid>

                <Grid item xs={12} md={8} data-aos="fade-right"
                      data-aos-duration="2000"
                      data-aos-once="true"
                      data-aos-delay="000">
                    <Typography variant={'h4'} sx={{
                        fontWeight: 800
                    }}>
                        {item?.title1}
                    </Typography>
                    <Typography variant={'h5'} sx={{color: "#592EA9", fontWeight: 800, my: 2}}>
                        {item?.title2}
                    </Typography>
                    <Typography variant="h6" sx={{
                        color: "#6D6E76", opacity: '0.8',
                        paddingBottom: '30px',
                    }} dangerouslySetInnerHTML={{
                        __html: fixStringToHtml(item?.description)
                    }}/>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default EventsCard;